import {LoginScreen} from "@/screens/LoginScreen";

export default function LoginIndex() {
    return (
        <LoginScreen />
    );
}
